var map = {
	"./BGMain.jpg": "5b98",
	"./BGMain10.jpg": "494d",
	"./BGMain11.jpg": "78c0",
	"./BGMain2.jpg": "f493",
	"./BGMain3.jpg": "f368",
	"./BGMain4.jpg": "f35f",
	"./BGMain5.jpg": "4e0a",
	"./BGMain6.jpg": "2030",
	"./BGMain8.jpg": "c64e",
	"./BGMain9.jpg": "ad35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6712";